import * as React from 'react';
import { NavLink } from "react-router-dom";
import { styled} from "@mui/material";
import { AccountCircle, Dashboard, ExitToApp, Person, School } from '@mui/icons-material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
// import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
// import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
// import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import scaLogo from "../../../assets/Images/Logos/SCALogo.png";
import "./NavigationBar.css";


const pages = [
  { label: 'Home', url: '/'},
  { label: 'Teachers', url: `/Teachers`},
];

const additionalPages = [
  { label: 'Highlights', url: `/Highlights`}
]

// eslint-disable-next-line
const menuOptions = [
  { label: 'Profile', icon: <Person /> },
  { label: 'Accounts', icon: <AccountCircle /> },
  { label: 'Dashboard', icon: <Dashboard /> },
  { label: 'Logout', icon: <ExitToApp /> },
];


function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [anchorElMaterials, setAnchorElMaterials] = React.useState(null);

  const open = Boolean(anchorElMaterials);

  const Offset = styled('div')(({ theme }) => theme.mixins.toolbar);


  const handleClick = (event) => {
    setAnchorElMaterials(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorElMaterials(null);
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

// eslint-disable-next-line
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

// eslint-disable-next-line
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleNestedLinkClick = () => {
    handleCloseNavMenu(); 
    handleClose(); 
  };

  return (
    <React.Fragment>
      <AppBar className='appBar' position="fixed">
        <Container maxWidth="xxl">
          <Toolbar disableGutters>
            <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }}>
              <NavLink to='/' end><img src={scaLogo} className='scaLogo' alt='SCA Logo' /></NavLink>
            </Box>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' },
                }}
              >
                {pages.map((page) => (
                  <MenuItem key={page.label} onClick={handleCloseNavMenu}>
                    <NavLink style={{paddingLeft: "15px"}} key={page.url} to={page.url}>{page.label}</NavLink>
                  </MenuItem>
                ))}

              <Button
                id="basic-button-resp"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                sx={{ color: "#02004e", marginLeft: "23px", marginRight: "20px"}}
              >
                Courses
              </Button>

                <Menu
                id="basic-menu"
                anchorEl={anchorElMaterials}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
                >
                  <NavLink to="/FirstFormPageDetail" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItem onClick={handleNestedLinkClick}>
                      <School fontSize="small" style={{ marginRight: '8px' }} />
                      First Form
                    </MenuItem>
                  </NavLink>
                  <NavLink to="/SecondFormPageDetails" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItem onClick={handleNestedLinkClick}>
                      <School fontSize="small" style={{ marginRight: '8px' }} />
                      Second Form
                    </MenuItem>
                  </NavLink>
                  <NavLink to="/ThirdFormPageDetails" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItem onClick={handleNestedLinkClick}>
                      <School fontSize="small" style={{ marginRight: '8px' }} />
                      Third Form
                    </MenuItem>
                  </NavLink>
                  <NavLink to="/FourthFormPageDetails" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItem onClick={handleNestedLinkClick}>
                      <School fontSize="small" style={{ marginRight: '8px' }} />
                      Fourth Form
                    </MenuItem>
                  </NavLink>
                  <NavLink to="/FrenchPageDetails" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItem onClick={handleNestedLinkClick}>
                      <School fontSize="small" style={{ marginRight: '8px' }} />
                      French Class
                    </MenuItem>
                  </NavLink>
                </Menu>
                  {additionalPages.map((page) => (
                    <MenuItem key={page.label} onClick={handleCloseNavMenu}>
                      <NavLink style={{paddingLeft: "15px"}} key={page.url} to={page.url}>{page.label}</NavLink>
                    </MenuItem>
                  ))}
              </Menu>
            </Box>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, mr: 1 }} >
              <NavLink to='/' end><img src={scaLogo} className='scaLogo' alt='SCA Logo' /></NavLink>
            </Box>

            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              {pages.map((page) => (
                <NavLink key={page.label} to={page.url} className={({ isActive }) => (isActive ? 'active' : undefined)}>
                  <Button
                    key={page.label}
                    onClick={handleCloseNavMenu}
                    sx={{ my: 2, color: 'white', display: 'block' }}
                  >
                    {page.label}
                  </Button>
                </NavLink>
              ))}

              <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
              >
                Course Materials
              </Button>

              <Menu
              id="basic-menu"
              anchorEl={anchorElMaterials}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
              >
                <NavLink to="/FirstFormPageDetails" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <MenuItem onClick={handleNestedLinkClick}>
                    <School fontSize="small" style={{ marginRight: '8px' }} />
                    First Form
                  </MenuItem>
                </NavLink>
                <NavLink to="/SecondFormPageDetails" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <MenuItem onClick={handleNestedLinkClick}>
                    <School fontSize="small" style={{ marginRight: '8px' }} />
                    Second Form
                  </MenuItem>
                </NavLink>
                <NavLink to="/ThirdFormPageDetails" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <MenuItem onClick={handleNestedLinkClick}>
                    <School fontSize="small" style={{ marginRight: '8px' }} />
                    Third Form
                  </MenuItem>
                </NavLink>
                <NavLink to="/FourthFormPageDetails" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <MenuItem onClick={handleNestedLinkClick}>
                    <School fontSize="small" style={{ marginRight: '8px' }} />
                    Fourth Form
                  </MenuItem>
                </NavLink>
                <NavLink to="/FrenchPageDetails" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <MenuItem onClick={handleNestedLinkClick}>
                    <School fontSize="small" style={{ marginRight: '8px' }} />
                    French Class
                  </MenuItem>
                </NavLink>
              </Menu>
              {additionalPages.map((page) => (
                <NavLink key={page.label} to={page.url} className={({ isActive }) => (isActive ? 'active' : undefined)}>
                  <Button
                    key={page.label}
                    onClick={handleCloseNavMenu}
                    sx={{ my: 2, color: 'white', display: 'block' }}
                  >
                    {page.label}
                  </Button>
                </NavLink>
              ))}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Offset />
    </React.Fragment>
  );
}
export default ResponsiveAppBar;
